import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import SeoHead from '../../components/common/SeoHead';
import api from '../../services/api';
import 'line-awesome/dist/line-awesome/css/line-awesome.min.css';

const UPLOADS_BASE = process.env.REACT_APP_UPLOADS_URL || 'https://www.businessmateworkflow.in';

const truncate = (text = '', wordCount = 25) => {
  const words = text.split(' ');
  if (words.length > wordCount) return words.slice(0, wordCount).join(' ') + '...';
  return text;
};

const Blog = () => {
  const [searchParams] = useSearchParams();
  const category = searchParams.get('category');
  const [blogs, setBlogs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, totalPages: 1 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = { page: pagination.page };
    if (category) params.category = category;

    Promise.all([
      api.get('/blog-list', { params }),
      api.get('/blog-categories')
    ])
      .then(([blogRes, catRes]) => {
        setBlogs(blogRes.data.data || []);
        setPagination(blogRes.data.pagination || { page: 1, totalPages: 1 });
        setCategories(catRes.data.data || []);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category, pagination.page]);

  const seo = {
    title: category
      ? `${categories.find((c) => c.slug === category)?.name || 'Category'} Articles | BusinessMate Workflow`
      : 'Blog | BusinessMate Workflow',
    metaDescription: 'Insights, guides, and updates on business registration, compliance, hiring, and growth.',
    canonical: `https://www.businessmateworkflow.in/blog${category ? `?category=${category}` : ''}`,
    robots: 'index,follow'
  };

  return (
    <main>
      <SeoHead seo={seo} />
      <Navbar />

     <section
  style={{
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
    padding: '40px 0',
    color: '#fff'
  }}
>
  <div className="container text-center">

    <h1
      style={{
        fontSize: 42,
        fontWeight: 700,
        marginBottom: 18,
             color:'#fff'
      }}
    >
      Business Insights & Growth Strategies
    </h1>

    <p
      style={{
        fontSize: 19,
        opacity: 0.9,
        maxWidth: 850,
        margin: '0 auto 15px',
        lineHeight: 1.7
      }}
    >
      Explore practical insights, expert guidance, and proven strategies
      designed to help you build, manage, and grow a successful business.
    </p>


  </div>
</section>

      <section style={{ padding: '60px 0' }}>
        <div className="container">
          {categories.length > 0 && (
            <div style={{ marginBottom: 32, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
              <Link to="/blog" style={{
                padding: '6px 16px', borderRadius: 20, textDecoration: 'none',
                background: !category ? '#06b590' : '#f1f5f9',
                color: !category ? '#fff' : '#334155', fontSize: 14, fontWeight: 500
              }}>All</Link>
              {categories.map((c) => (
                <Link key={c.id} to={`/blog?category=${c.slug}`} style={{
                  padding: '6px 16px', borderRadius: 20, textDecoration: 'none',
                  background: category === c.slug ? '#06b590' : '#f1f5f9',
                  color: category === c.slug ? '#fff' : '#334155', fontSize: 14, fontWeight: 500
                }}>{c.name}</Link>
              ))}
            </div>
          )}

          {loading ? (
            <p className="text-center">Loading articles...</p>
          ) : blogs.length === 0 ? (
            <p className="text-center">No articles published yet.</p>
          ) : (
            <div className="row g-4">
              {blogs.map((blog) => (
                <div className="col-lg-4 col-md-6" key={blog.id}>
                  <Link to={`/blog/${blog.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                    <div style={{ border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden', height: '100%' }}>
                      {blog.image_url && (
                        <img
                          src={`${UPLOADS_BASE}/${blog.image_url}`}
                          alt={blog.image_alt_text || blog.title}
                          style={{ width: '100%', height: 180, objectFit: 'cover' }}
                        />
                      )}
                      <div style={{ padding: 20 }}>
                        <h2 style={{ fontSize: 19, fontWeight: 600, marginBottom: 10 }}>{blog.title}</h2>
                        <p style={{ color: '#64748b', fontSize: 14 }}>{truncate(blog.excerpt, 20)}</p>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 12, color: '#94a3b8', fontSize: 13 }}>
                          <i className="las la-user" />
                          <span>{blog.author || 'BusinessMate Workflow'}</span>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          )}

          {pagination.totalPages > 1 && (
            <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 40 }}>
              {Array.from({ length: pagination.totalPages }, (_, i) => i + 1).map((p) => (
                <button
                  key={p}
                  onClick={() => setPagination((prev) => ({ ...prev, page: p }))}
                  style={{
                    padding: '6px 14px', borderRadius: 6, border: '1px solid #e2e8f0',
                    background: pagination.page === p ? '#06b590' : '#fff',
                    color: pagination.page === p ? '#fff' : '#334155', cursor: 'pointer'
                  }}
                >
                  {p}
                </button>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default Blog;
